export enum PlacedOnHoldSource {
  USER_ACTION = "user_action",
  AUTOMATION = "automation",
  MARKETPLACE_SYNC = "marketplace_sync",
  ADDRESS_VERIFICATION_FAILURE = "address_verification_failure",
}

export enum ReleasedFromHoldSource {
  USER_ACTION = "user_action",
  TIMER = "timer",
  MARKETPLACE_SYNC = "marketplace_sync",
}
